module.exports = [{
      plugin: require('D:/Sources/beitraege/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
